export const URL = process.env.REACT_APP_ENDPOINT_URL; // Will be picked from .env
export const API_URL = `http://${URL}/api`;
export const APP_URL = `http://${URL}/graphql`;
export const SUBSCRIPTION_PAYMENT = `${API_URL}/v1/subscription`;
export const WEB_SOCKET_APP_URL = `ws://${URL}/subscriptions`;
export const PAYMENT_API = `${API_URL}/v1/payment`;
export const UPDATE_USER_SUBSCRIPTION_INFO = `${API_URL}/v1/updateSubscriptionInfo`;
export const UPDATE_USER_SUBSCRIPTION = `${API_URL}/v1/updateSubscription`;
export const ALL_SAVED_CARDS = `${API_URL}/v1/customer-paymentMethod`;
export const CANCEL_ACTIVEBOOSTER_TRANSACTION = `${API_URL}/v1/cancel-booster-subscription`;
export const CANCEL_ACTIVE_TRANSACTION = `${API_URL}/v1/cancel-subscription`;
export const VIEW_ALL_TRANSACTONS = `${API_URL}/v1/customer-transactions`;
export const CARD_DETAILS_BY_ID = `${API_URL}/v1/paymentMethodDetailById `;
export const UPDATE_CARD_DETAILS = `${API_URL}/v1/paymentMethodUpdate`;
export const DELETE_SAVED_CARD = `${API_URL}/v1/paymentMethodDelete`;
export const CREATE_CARD_DETAILS = `${API_URL}/v1/attach-customer-payment-method`;
export const ADD_BOOST_PAYMENT = `${API_URL}/v1/booster-subscription`;
export const FETCH_URL = `http://${URL}/api/get-file-upload-url`;

export const S3_BUCKET_LIVE = "equip-now-media";

export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY; // Will be picked from .env

export const MONTH_YEAR_DATE_FORMAT = "MMMM Do YYYY";
export const MONTH_YEAR_DATE_TIME_FORMAT = "MMMM Do YYYY hh:mm a";
export const DEFAULT_DATE_TIME_FORMAT = "MM-DD-YYYY hh:mm:ss";
export const MONTH_DATE_YEAR_fORMAT = "MMM DD, YYYY";

export const MODULES = [
  { name: "Dashboard", value: false },
  { name: "Organizations", value: false },
  { name: "Assets", value: false },
  { name: "Buying", value: false },
  { name: "Selling", value: false },
  { name: "Become a Seller", value: false },
  { name: "Services", value: false },
  { name: "Support", value: false },
  { name: "Employees", value: false },
  { name: "My Account", value: false },
  { name: "Master Data", value: false },
];

export const MODULES_ARRAY = [
  "Dashboard",
  "Organizations",
  "Assets",
  "Buying",
  "Selling",
  "Become a Seller",
  "Services",
  "Support",
  "Employees",
  "My Account",
  "Master Data",
];

export const countryCode = [
  {
    value: "USD",
    label: "+1",
  },
  {
    value: "IND",
    label: "+91",
  },
  {
    value: "FRANCE",
    label: "+33",
  },
];

export const NEGOTIATION_CALLING_ACTION = "negotiation_call";
export const NEGOTIATION_STATUS_SALE_PENDING = "sale_pending";

export const ENQUIRY_CALLING_ACTION = "enquiry_call";

export const TIMER_ACTION_AM = "counter_offer_timer";
export const TIMER_ACTION_BUYER = "initial_offer_timer";
export const TIMER_ACTION_COMPLETE_PURCHASE = "buyer_purchase_complete_timer";

export const OFFER_ACCEPTED_TEXT = "offer_accepted";
export const BACKUP_OFFER_TEXT = "backup offer";

export const ROLE_NORMAL = "normal";
export const ROLE_ASSET_MANAGER = "asset_manager";
export const ROLE_BOA = "back_office_admin";
export const ROLE_BUYER = "buyer";
export const ROLE_GUEST = "guest";
export const ROLE_SUPER_ADMIN = "super_admin";
export const ROLE_C_ADMIN = "company_admin";
export const ROLE_SELLER = "seller";
export const ROLE_TRANS_COMP = "transport_company";
export const ROLE_INDIVIDUAL = "Individual owner";
export const ROLE_CONSULTANT = "consultant";
export const ROLE_FIN_COMP = "finance_company";

export const PERMISSION_READ = "read";
export const PERMISSION_CREATE = "create";
export const PERMISSION_FULLACCESS = "fullAcess";
export const PERMISSION_UPDATE = "update";
export const PERMISSION_DELETE = "delete";
export const ACTION_ASSET_LIST = "asset_card";

export const BUSINESSDD_TYPE_OTHER = "BUS_OTHERS";
export const COMPANYDD_TYPE_OTHER = "COM_OTHERS";

export const SELF_OWNED = "SELF_OWNED";
export const HAS_LOAN = "HAS_LOAN";

export const TOKEN = "token";
export const PIN = "pin";

export const SELLER = "Seller";
export const BUYER = "Buyer";
export const GUEST = "Guest";

export const ASSET_MANAGER = "Asset Manager";
export const LOCAL_STORAGE_ROLES = "roles";
